"use strict";
exports.__esModule = true;
var tools_1 = require("./tools");
var Route = /** @class */ (function () {
    function Route(router, url, callback) {
        this.router = router;
        this.url = url;
        this.callback = callback;
        this.filter = {};
        this._preRoute = [];
        if (url instanceof RegExp) {
            return;
        }
        var vars = {};
        var varPos = [];
        var text = [];
        var parts = url.split(/\/+/g).filter(function (p) {
            return p.length > 0;
        }).map(function (part) {
            if (part.match(/^:[a-z_][a-z0-9_]*$/i)) {
                vars[part.substr(1)] = {};
                varPos.push(part.substr(1));
                text.push(null);
                return ['/', vars[part.substr(1)]];
            }
            text.push(part);
            return ['/', part];
        });
        this.minLength = text.length;
        this.maxLength = text.length;
        this.url = url;
        this.parts = Array.prototype.concat.apply([], parts);
        this.vars = vars;
        this.varPos = varPos;
        this.text = text;
    }
    Route.prototype.preRoute = function (callback) {
        tools_1.checkFunction(callback);
        this._preRoute.push(callback);
        return this;
    };
    Route.prototype.name = function (name) {
        this.router.routesByName[name] = this;
        return this;
    };
    Route.prototype.setDefault = function (name, value) {
        if (!this.vars.hasOwnProperty(name)) {
            throw new Error('cannot find variable ' + name);
        }
        this.vars[name]['default'] = value;
        return this;
    };
    Route.prototype.isCandidate = function (parts, vars) {
        var i, e, x = 0, zvar;
        // Mininum length?
        if (this.minLength > parts.length || this.maxLength < parts.length) {
            return false;
        }
        // Fail sooner, check all the static content (no placeholders/variables)
        for (i = 0, e = 0; i < parts.length && e < this.text.length; ++e, ++i) {
            if (this.text[e] !== null && parts[i] !== this.text[e]) {
                return false;
            }
        }
        // check all the variables and their filters/validators
        for (i = 0, e = 0; i < parts.length && e < this.text.length; ++e, ++i) {
            if (this.text[e] === null) {
                zvar = this.varPos[x++];
                if (this.filter[zvar] && !this.filter[zvar](parts[e])) {
                    return false;
                }
                else if (this.router.globalFilter[zvar] && !this.router.globalFilter[zvar](parts[e])) {
                    return false;
                }
                vars[zvar] = parts[e];
            }
        }
        for (i = 0; i < this._preRoute.length; ++i) {
            if (this._preRoute[i]() === false) {
                return false;
            }
        }
        return true;
    };
    Route.prototype.generate = function (args) {
        var _this = this;
        var id = 0;
        return this.parts.map(function (part) {
            if (typeof part === 'object' && typeof part !== 'string') {
                var name_1 = _this.varPos[id];
                var value = args[id++];
                if (!value && value !== 0) {
                    throw new Error('cannot find variable ' + part + ' in the arguments');
                }
                if (_this.router.globalFilter[name_1] && !_this.router.globalFilter[name_1](value)) {
                    throw new Error(value + ' is not a valid ' + name_1);
                }
                return value;
            }
            return part;
        });
    };
    Route.prototype.generateByRouteParts = function (routeParts) {
        var _this = this;
        var id = 0;
        return this.parts.map(function (part) {
            if (typeof part === 'object' && typeof part !== 'string') {
                var name_2 = _this.varPos[id++];
                var value = routeParts[name_2];
                if (!value && value !== 0) {
                    throw new Error('cannot find variable ' + part + ' in the arguments');
                }
                if (_this.router.globalFilter[name_2] && !_this.router.globalFilter[name_2](value)) {
                    throw new Error(value + ' is not a valid ' + name_2);
                }
                return value;
            }
            return part;
        });
    };
    return Route;
}());
exports.Route = Route;
//# sourceMappingURL=Route.js.map